import type { AppSnapshot, PlaybackSnapshot, DialogSnapshot } from "./types.js";
// Stable snapshots let React subscribe without moving audio/files into component lifetimes.
export function createStore<T>(initial: T) {
  let snapshot = initial;
  const listeners = new Set<() => void>();
  let commit: (update: () => void) => void = (update) => update();
  return {
    getSnapshot: () => snapshot,
    subscribe(listener: () => void) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    setCommit(fn: (update: () => void) => void) {
      commit = fn;
    },
    publish(value: T) {
      if (Object.is(snapshot, value)) return;
      snapshot = value;
      commit(() => {
        for (const listener of listeners) listener();
      });
    },
  };
}
export const appStore = createStore<AppSnapshot | null>(null);
export const playbackStore = createStore<PlaybackSnapshot | null>(null);
export const dialogStore = createStore<DialogSnapshot | null>(null);
export const toastStore = createStore<string | null>(null);
